<template>
    <form
        class="register-form"
        id="f-reg-webinar"
        @submit.prevent="handleRegisterForm()"
        novalidate
    >
        <div class="register-form__wrapper">
            <div class="register-form__heading">
                <h2>Zarejestruj się</h2>
                <p>
                    Posiadasz już konto?
                    <a href="/logowanie"> Zaloguj się &rarr;</a>
                </p>
                <p class="register-form__text">
                    Jeżeli w ciągu ostatniego roku byłaś/eś uczestnikiem
                    konferencji organizowanych przez Med Space, Twoje konto już
                    istnieje - <a href="/logowanie">zaloguj się</a> korzystając
                    z niego.
                </p>
            </div>
            <div class="error alert alert-danger" v-if="professionError">
                <p style="color: red">Pola oznaczone <b>*</b> są wymagane</p>
            </div>
            <div
                v-if="errorMessage.length > 0"
                class="register-form__error-box"
            >
                <p>Błąd: {{ errorMessage }}</p>
            </div>
            <div class="register-form__section">
                <form-select
                    label="Zawód"
                    name="profession"
                    :values="professions"
                    v-model="profession"
                    icon="work"
                    :errorMessages="errorMessages"
                >
                </form-select>
                <form-input
                    label="Adres e-mail"
                    v-model="email"
                    :modelValue="email"
                    :register="true"
                    type="email"
                    icon="alternate_email"
                    name="email"
                    :errorMessages="errorMessages"
                ></form-input>
                <form-input
                    label="Imię"
                    v-model="name"
                    :modelValue="name"
                    type="text"
                    icon="person"
                    name="name"
                    :errorMessages="errorMessages"
                ></form-input>
                <form-input
                    label="Nazwisko"
                    v-model="last_name"
                    :modelValue="last_name"
                    type="text"
                    icon="person"
                    name="last_name"
                    :errorMessages="errorMessages"
                ></form-input>
            </div>
            <div class="register-form__section">
                <form-input
                    label="Hasło"
                    v-model="password"
                    :modelValue="password"
                    type="password"
                    name="password"
                    icon="lock"
                    :errorMessages="errorMessages"
                ></form-input>
                <form-input
                    label="Powtórz hasło"
                    v-model="password_confirm"
                    :modelValue="password_confirm"
                    type="password"
                    name="password_confirm"
                    icon="lock"
                    :errorMessages="errorMessages"
                ></form-input>
            </div>
            <div class="register-form__section">
                <form-input
                    label="Numer telefonu"
                    v-model="phone"
                    :modelValue="phone"
                    type="phone"
                    icon="call"
                    name="phone"
                    :errorMessages="errorMessages"
                ></form-input>

                <form-input
                    v-if="
                        ['1', '2', '5', '7', '10', '11', '14'].includes(
                            profession
                        )
                    "
                    label="Podaj numer prawa wykonywania zawodu"
                    v-model="pwz_number"
                    :modelValue="pwz_number"
                    type="text"
                    icon="tag"
                    name="pwz_number"
                    :errorMessages="errorMessages"
                ></form-input>

                <form-input
                    v-if="profession != 4 && profession != 6"
                    label="Miejsce pracy"
                    v-model="work_place"
                    :modelValue="work_place"
                    type="text"
                    icon="work"
                    name="work_place"
                    :errorMessages="errorMessages"
                ></form-input>

                <form-input
                    v-if="profession == 1 || profession == 7"
                    label="Specjalizacja"
                    v-model="specialization"
                    :modelValue="specialization"
                    type="text"
                    icon="stethoscope_check"
                    name="specialization"
                    :errorMessages="errorMessages"
                ></form-input>

                <form-input
                    v-if="profession == 4"
                    label="Uniwersytet"
                    v-model="university"
                    :modelValue="university"
                    type="text"
                    icon="school"
                    name="university"
                    :errorMessages="errorMessages"
                ></form-input>

                <form-input
                    v-if="profession == 4"
                    label="Podaj numer legitymacji studenckej"
                    v-model="card"
                    :modelValue="card"
                    type="text"
                    icon="tag"
                    name="card"
                    :errorMessages="errorMessages"
                ></form-input>

                <form-input
                    v-if="profession == 6"
                    label="Podaj firmę, której jesteś przedstawicielem"
                    :modelValue="company_represented"
                    type="text"
                    icon="business_center"
                    name="company_represented"
                    v-model="company_represented"
                    :error-messages="errorMessages"
                ></form-input>
            </div>
            <div
                class="register-form__section register-form__section--agreements"
            >
                <form-user-agreement-input
                    :require="1"
                    :label="privacy_agreement_label"
                    :modelValue="privacy_agreeement"
                    v-model="privacy_agreeement"
                    name="privacy_agreeement"
                    :error-messages="errorMessages"
                ></form-user-agreement-input>
                <form-user-agreement-input
                    :require="0"
                    :label="marketing_agreement_label"
                    :modelValue="marketing_agreeement"
                    v-model="marketing_agreeement"
                    name="marketing_agreeement"
                    :error-messages="errorMessages"
                ></form-user-agreement-input>
            </div>

            <button class="btn btn-primary register-form__register-button">
                ZAREJESTRUJ SIĘ
            </button>
        </div>
    </form>
</template>

<script>
import FormInput from "./formInput";
import FormSelect from "./formSelect";
import Spinner from "vue-simple-spinner";
import FormUserType from "./formUserType";
import FormUserAgreementInput from "./formUserAgreementInput.vue";

export default {
    props: ["privacy_agreement_content", "marketing_agreement_content"],
    components: {
        FormUserType,
        FormInput,
        Spinner,
        FormSelect,
        FormUserAgreementInput,
    },
    data() {
        return {
            email: null,
            password: null,
            password_confirm: null,
            name: null,
            last_name: null,
            profession: null,
            specialization: null,
            pwz_number: null,
            company_name: null,
            street: null,
            card: null,
            university: null,
            user_type: "person",
            house_number: null,
            flat_number: null,
            city: null,
            post_code: null,
            nip: null,
            work_place: null,
            errorMessages: null,
            successStatus: null,
            processing: false,
            company_represented: null,
            phone: null,
            professionError: false,
            professions: {
                1: "Lekarz",
                2: "Personel pielęgniarski",
                3: "Ratownik medyczny",
                4: "Student",
                5: "Diagnosta laboratoryjny",
                6: "Przedstawiciel medyczny",
                7: "Lekarz rezydent",
                8: "Inny",
                9: "Dietetyk",
                10: "Farmaceuta",
                11: "Fizjoterapeuta",
                12: "Psycholog",
                13: "Pracownik administracyjny placówki medycznej",
                14: "Położna",
                15: "Technik analityki medycznej",
            },
            privacy_agreeement: 0,
            marketing_agreeement: 0,
            privacy_agreement_label: this.privacy_agreement_content,
            marketing_agreement_label: this.marketing_agreement_content,
            errorMessage: "",
        };
    },

    methods: {
        handleRegisterForm() {
            if (this.privacy_agreeement === 1) {
                axios
                    .post("/api/register", {
                        email: this.email,
                        password: this.password,
                        password_confirm: this.password_confirm,
                        name: this.name,
                        last_name: this.last_name,
                        profession: this.profession,
                        specialization: this.specialization,
                        pwz_number: this.pwz_number,
                        company_name: this.company_name,
                        street: this.street,
                        card: this.card,
                        university: this.university,
                        house_number: this.house_number,
                        flat_number: this.flat_number,
                        city: this.city,
                        post_code: this.post_code,
                        nip: this.nip,
                        work_place: this.work_place,
                        user_type: this.user_type,
                        company_represented: this.company_represented,
                        phone: this.phone,
                        privacy_agreeement: this.privacy_agreeement,
                        marketing_agreeement: this.marketing_agreeement,
                    })
                    .then((response) => {
                        this.processing = true;
                    })
                    .then((response) => {
                        this.processing = false;
                        window.location.href = "/podziekowanie";
                    })
                    .catch((error) => {
                        this.errorMessages = error.response.data.errors;
                        if (error.response.data.errors.profession) {
                            this.professionError = true;
                        }
                    })
                    .then((error) => {
                        console.log(error);
                        // window.scrollTo(
                        //     0,
                        //     document.querySelector(".error").offsetParent.offsetTop
                        // );
                    });
            } else {
                this.errorMessage = "Zgoda wymagana";
            }
        },
    },
};
</script>
